import { GraphicalDataSourceObjectBase } from "abweb/dto/generated/gds/GraphicalDataSourceObjectBase";
export class GraphicalDataSourceObject extends GraphicalDataSourceObjectBase {
  /**
   * A reference to the record from the dataSource associated with this object.
   * This is set by anyone who wants it, so it may be undefined when you try to use it. It would be set in a lazy manner.
   */

  constructor() {
    super();
  }
}
//# sourceMappingURL=GraphicalDataSourceObject.js.map
